"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDropZone = exports.StyledListItemCheckbox = exports.StyledListItem = exports.StyledCustomizeViewHeader = exports.StyledCustomizeViewActionContainer = exports.StyledDragDropList = exports.StyledCustomizeViewContainer = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledCustomizeViewContainer = styled_components_1.default.div `
  width: 25rem;
  padding: 0.5rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;

  .customize-view-container-title {
    text-transform: uppercase;
  }

  .list-container {
    flex: 1;
  }
`;
exports.StyledDragDropList = (0, styled_components_1.default)(ui_components_1.SimpleDragDropList) `
  display: flex;
  flex-direction: column;
  overflow: auto;
`;
exports.StyledCustomizeViewActionContainer = styled_components_1.default.div `
  padding: 0.5rem;
  // TODO: fix negative margins
  margin: ${({ theme }) => theme.spacing(0, -1, -1)};
  background-color: ${ui_components_1.baseColors.background000};
  margin-top: auto;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;
exports.StyledCustomizeViewHeader = styled_components_1.default.div `
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  text-transform: uppercase;
  color: ${ui_components_1.baseColors.primaryBlueDark500};

  .title-container {
    display: flex;
    align-items: center;
  }
`;
exports.StyledListItem = styled_components_1.default.div `
  height: ${({ $height }) => `${$height}px`};

  display: flex;
  align-items: center;

  font-size: 0.875rem;
  font-weight: 400;
  color: ${ui_components_1.baseColors.primaryBlueDark500};

  opacity: ${({ $isDragging }) => ($isDragging ? 0 : 1)};
`;
exports.StyledListItemCheckbox = (0, styled_components_1.default)(ui_components_1.Checkbox) `
  &.Mui-disabled.Mui-checked {
    color: ${ui_components_1.baseColors.primaryBlueMed200};
  }
`;
exports.StyledDropZone = styled_components_1.default.div `
  height: 3rem;
  background: ${ui_components_1.baseColors.primaryBlueAccent050};
`;
